export default {
  components: {},
  name: 'holdOrderDialog',
  props: ['componentData'],
  data() {
    const _this = this;
    return {
      holdBtnClass: '',
      loading: false,
      formConfig: {
        formValue: {
          HOLD_ORDER_REASON: '',
          IS_AUTO_RELEASE: false,
          RELEASE_TIME_TYPE: '',
          RELEASE_TIME: '',
          DAY_TYPE: '',
          FIXED_DURATION: 1,
          TIME_UNIT: ''
        },
        formData: [
          {
            style: 'dropSelect',
            width: '24',
            itemdata: {
              colid: 1700815914,
              filterConds: [
                { fixcolumn: 'TYPE', refobjid: 2 },
                { fixcolumn: 'DATA_TYPE', refobjid: 0 },
                { fixcolumn: 'ISACTIVE', refobjid: 'Y' },
              ],
              colname: 'HOLD_DETENTION_ORDER_REASON', // 当前字段的名称
              fkdisplay: 'drp', // 外键关联类型
              inputname: 'HOLD_DETENTION_ORDER_REASON:REASON', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: true, // 是否必填
              name: t('HOLD单原因'), // HOLD单原因 input前面显示的lable值
              readonly: false, // 是否可编辑，对应input   readonly属性
              pid: '',
              valuedata: '' // 这个是选择的值
            },
            oneObj: (val) => {
              this.formConfig.formValue.HOLD_ORDER_REASON = val.pid
              this.formConfig.formValue.HOLD_ORDER_REASON_MSG = val.valuedata
            }
          },
          // {
          //   style: 'select',
          //   label: t('HOLD单原因'),
          //   width: '24',
          //   value: 'HOLD_ORDER_REASON',
          //   setRequired: 'required',
          //   options: [
          //     {
          //       value: '1',
          //       label: t('直播HOLD单') // 直播HOLD单
          //     },
          //     {
          //       value: '2',
          //       label: '其它HOLD单' // 其它HOLD单
          //     }
          //   ]
          // },
          {
            style: 'checkbox',
            label: t('自动释放'), // 自动释放
            value: 'IS_AUTO_RELEASE',
            width: 24
          }
        ],
        ruleValidate: {
          HOLD_ORDER_REASON: [{ required: true, message: ' ', trigger: 'blur' }]
        }
      },
      elseFormData: [
        {
          style: 'select',
          label: t('释放时点'),
          width: 24,
          value: 'RELEASE_TIME_TYPE',
          options: [
            {
              label: t('指定时点释放'),
              value: '1'
            },
            {
              label: t('固定时长后释放'),
              value: '2'
            }
          ],
          selectChange: () => {
            _this.formConfig.formValue.RELEASE_TIME = '';
            _this.formConfig.formValue.DAY_TYPE = '';
            _this.formConfig.formValue.FIXED_DURATION = 1;
            _this.formConfig.formValue.TIME_UNIT = '';
            if (_this.formConfig.formValue.RELEASE_TIME_TYPE === '1') _this.formConfig.formData[3] = _this.elseFormData[1];
            else _this.formConfig.formData[3] = _this.elseFormData[2];
          }
        },
        {
          style: 'date',
          type: 'datetime',
          value: 'RELEASE_TIME',
          label: ' ',
          class: 'releaseClass',
          width: 24,
          format: 'yyyy-MM-dd HH:mm:ss', // 格式参照burgeonui
          placeholder: '',
          options: {
            disabledDate(date) {
              return date && date.valueOf() < Date.now() - 86400000;
            }
          }
        },
        {
          style: 'formCompile',
          label: ' ',
          slotName: 'formCompile',
          width: 24,
          class: 'releaseClass',
          options1: [
            {
              label: t('下单时间'),
              value: '1'
            },
            {
              label: t('付款时间'),
              value: '2'
            },
            {
              label: t('创建时间'), // 创建时间
              value: '3'
            },
            {
              label: t('卡单时间'), // 创建时间
              value: '4'
            }
          ],
          options2: [
            {
              label: t('分钟'),
              value: '1'
            },
            {
              label: t('小时'),
              value: '2'
            },
            {
              label: t('天'),
              value: '3'
            }
          ]
        }
      ],
      btnConfig: {
        typeAll: 'default',
        btnsite: 'right',
        buttons: [
          {
            text: t('取消'),
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            }
          },
          {
            type: 'primary', // 按钮类型
            text: t('确定'),
            btnclick: () => {
              this.confirmChange();
            }
          }
        ]
      }
    };
  },
  watch: {
    'formConfig.formValue.IS_AUTO_RELEASE': {
      handler(newValue, oldVal) {
        const formData = this.formConfig.formData;
        const oldForm = [formData[0], formData[1]];
        if (newValue) {
          this.holdBtnClass = 'holdBtnClass';
          this.formConfig.formData = [...oldForm, this.elseFormData[0]];
        }
        else {
          this.formConfig.formData = oldForm;
          this.formConfig.formValue.RELEASE_TIME_TYPE = '';
          this.formConfig.formValue.RELEASE_TIME = '';
          this.formConfig.formValue.DAY_TYPE = '';
          this.formConfig.formValue.FIXED_DURATION = 1;
          this.formConfig.formValue.TIME_UNIT = '';
        }
      }
    }
  },
  methods: {
    // 确定请求
    async confirmInfo(data) {
      this.loading = true;
      const res = await this.service.orderCenter.managementOrderHold(data);
      if (res.data.code === 0) {
        this.$Message.success(res.data.message); // 'HOLD单成功'
        if (this.$route.params.customizedModuleId == 2627) {
          // 2627: 零售发货单列表
          this.$parent.$parent.closeConfirm();
          this.$nextTick(() => {
            this.$parent.$parent.$parent.query();
          });
        } else {
          this.$parent.$parent.closeConfirm();
          this.$nextTick(() => {
            this.$parent.$parent.$parent.load();
          });
        }
      } else if (res.data.code == 1 && res.data.data) {
        let tabData = res.data.data.map((row, index) => {
          row.INDEX = ++index;
          row.BILL_NO = row.objid;
          row.RESULT_MSG = row.message;
          return row
        });
        $utils.tipShow('confirm', this, res, res.data.message, function (h) {
          return h('Table', {
            props: {
              columns: [
                {
                  title: t('序号'),
                  key: 'INDEX'
                },
                {
                  title: t('单据编号'), // 单据编号
                  key: 'BILL_NO'
                },
                {
                  title: t('失败原因'), // 失败原因
                  key: 'RESULT_MSG'
                }
              ],
              // data:res.data.data.CANCEL_ORDER_ERROR_INFOS
              data: tabData
            }
          })
        })
      } else {
        // $fcError(res.data.message);
      }
      this.loading = false;
    },
    // 确定事件校验和参数赋值
    confirmVerifyAssignment() {
      const params = {};
      const formValue = this.formConfig.formValue;
      // 判断HOLD单原因
      if (!formValue.HOLD_ORDER_REASON) {
        // return { message: "HOLD单原因不能为空" };
        return { message: t('HOLD单原因不能为空') };
      }
      params.HOLD_ORDER_REASON = formValue.HOLD_ORDER_REASON;
      params.HOLD_ORDER_REASON_MSG = formValue.HOLD_ORDER_REASON_MSG;
      // 判断是否有勾选自动释放
      if (formValue.IS_AUTO_RELEASE) {
        params.IS_AUTO_RELEASE = 'Y';
        params.RELEASE_TIME_TYPE = formValue.RELEASE_TIME_TYPE;
        // 判断释放时点
        if (formValue.RELEASE_TIME_TYPE === '1') {
          // 判断指定时点释放的时间
          if (!formValue.RELEASE_TIME) {
            return { message: t('指定时点释放的时间不能为空') }; // 指定时点释放的时间不能为空
          }
          if (new Date(formValue.RELEASE_TIME).getTime() < Date.now()) {
            return { message: t('指定时点释放的时间不能小于当前时间') }; // 指定时点释放的时间不能小于当前时间
          }
          params.RELEASE_TIME = $utils.dateFormat(formValue.RELEASE_TIME, 'yyyy-MM-dd hh:mm:ss');
        } else if (formValue.RELEASE_TIME_TYPE === '2') {
          // 判断固定时长后释放的相应参数
          if (
            formValue.DAY_TYPE
            && formValue.FIXED_DURATION
            && formValue.TIME_UNIT
          ) {
            if (formValue.FIXED_DURATION.toString().indexOf('.') >= 0) {
              return { message: t('固定时长后释放的固定时长只能是整数') }; // 固定时长后释放的固定时长只能是整数
            }
            // params.RELEASE_DAY_TYPE = +formValue.DAY_TYPE;
            // params.FIXED_DURATION = formValue.FIXED_DURATION;
            // params.TIME_UNIT = +formValue.TIME_UNIT;
            params.DAY_TYPE = formValue.DAY_TYPE;
            params.FIXED_DURATION = formValue.FIXED_DURATION;
            params.TIME_UNIT = formValue.TIME_UNIT;
          } else {
            return { message: t('固定时长后释放的相关数据不能为空') }; // 固定时长后释放的相关数据不能为空
          }
        } else {
          return { message: t('释放时点不能为空') }; // 释放时点不能为空
        }
      } else {
        params.IS_AUTO_RELEASE = 'N';
      }
      return {
        params
      };
    },
    // 确定事件
    confirmChange() {
      const requestData = this.confirmVerifyAssignment();
      if (requestData.message) {
        $fcError(requestData.message);
        return
      }
      const ids = this.componentData.ids
      const params = {
        // IDS: [this.componentData.ids],
        ...requestData.params,
      };
      if (Array.isArray(ids)) {
        params.IDS = ids // 列表
      } else {
        params.IDS = [ids] // 详情
      }
      // let rows = this.componentData.ids;
      // let list = [];
      // list = rows.map(it => ({ ID: it.ID, BILL_NO: it.BILL_NO }));
      // const params = {
      //   ID_AND_BILL_NO_LIST: list,
      //   ...requestData.params
      // };
      // params.HOLD_ORDER_REASON *= 1;
      // params.RELEASE_TIME_TYPE *= 1;
      this.confirmInfo(params);
    }
  }
};
